module.exports = __webpack_public_path__ + "img/DressToProgress2.c5fec23a.png";